import { IMAGES } from "./content";

// Dedizierte Conversion-Landingpages für Anbieter- & Gastarife (Teil 5.4 / 5.5)
export const TARIFE = {
  "stromanbieter-vergleichen": {
    slug: "stromanbieter-vergleichen",
    eyebrow: "Stromanbieter vergleichen",
    titleLines: ["Stromanbieter", 'unabhängig <span class="font-serif italic text-blue-700">vergleichen.</span>'],
    subtitle:
      "Über 1.000 Stromanbieter, hunderte Tarifmodelle – wir behalten den Überblick und finden für Sie die wirtschaftlich beste Lösung. Ohne Portalprovision, ohne versteckte Interessen.",
    image: IMAGES.powerLines,
    ctaTopic: "strom",
    intro:
      "Vergleichsportale zeigen oft nur einen Ausschnitt des Marktes – und verdienen an jedem Wechsel mit. Wir arbeiten anders: Als unabhängige Energieberatung prüfen wir den gesamten Markt, inklusive börsennaher Beschaffung, und empfehlen ausschließlich das, was für Sie wirtschaftlich sinnvoll ist.",
    sections: [
      {
        heading: "Warum ein reiner Preisvergleich zu kurz greift",
        body: "Der günstigste Cent-Preis nützt wenig, wenn Boni nur im ersten Jahr gelten, Preisgarantien fehlen oder die Laufzeit zur Falle wird. Wir bewerten Tarife ganzheitlich: Arbeitspreis, Grundpreis, Vertragsbindung, Kündigungsfristen und die Bonität des Anbieters.",
      },
      {
        heading: "Worauf es beim Anbietervergleich wirklich ankommt",
        body: "Entscheidend sind eine echte Preisgarantie auf Beschaffungs- und Vertriebskosten, faire Kündigungsfristen und ein solider Versorger. Bei Gewerbe kommt die passende Beschaffungsstrategie hinzu – Termin- oder Spotmarkt, SLP oder RLM. Genau hier setzen wir an.",
      },
      {
        heading: "Für Privat- und Gewerbekunden",
        body: "Ob Ein-Personen-Haushalt oder Filialunternehmen mit vielen Zählpunkten – wir vergleichen individuell und übernehmen auf Wunsch den kompletten Wechsel: Kündigung, Anmeldung beim neuen Anbieter und die gesamte Abwicklung.",
      },
    ],
    benefits: [
      { title: "Gesamter Markt statt Portal-Ausschnitt", text: "Wir vergleichen anbieterübergreifend – auch Tarife abseits der bekannten Vergleichsportale." },
      { title: "Ganzheitliche Bewertung", text: "Nicht nur der Preis zählt, sondern Preisgarantie, Laufzeit, Boni und Anbieterbonität." },
      { title: "Unabhängig & neutral", text: "Keine Portalprovision, keine versteckten Interessen – nur Ihr wirtschaftlicher Vorteil." },
      { title: "Wechselservice inklusive", text: "Auf Wunsch übernehmen wir die komplette Abwicklung des Anbieterwechsels für Sie." },
    ],
    stat: { value: "1.000+", label: "Stromanbieter, die wir für Sie im Blick behalten" },
    faqs: [
      { q: "Ist der Vergleich wirklich unabhängig?", a: "Ja. Wir sind nicht an einen Anbieter gebunden und erhalten keine Portalprovision. Unsere Empfehlung richtet sich ausschließlich nach Ihrem wirtschaftlichen Vorteil." },
      { q: "Was kostet mich der Vergleich?", a: "Der Vergleich und unsere Beratung sind für Sie kostenlos und unverbindlich. Vergütet werden wir – falls es zu einem Wechsel kommt – über den gewählten Anbieter." },
      { q: "Welche Unterlagen brauche ich?", a: "Für eine erste Einschätzung genügt Ihre letzte Jahresabrechnung. Daraus lesen wir Verbrauch, Anbieter und Konditionen aus – persönlich und unabhängig geprüft." },
    ],
  },

  anbieterwechsel: {
    slug: "anbieterwechsel",
    eyebrow: "Anbieterwechsel",
    titleLines: ["Anbieterwechsel –", 'ohne <span class="font-serif italic text-blue-700">Aufwand.</span>'],
    subtitle:
      "Sie möchten den Stromanbieter oder Gasversorger wechseln, aber ohne Papierkram und Risiko? Wir übernehmen den kompletten Wechsel – von der Kündigung bis zur lückenlosen Versorgung.",
    image: IMAGES.industry,
    ctaTopic: "strom",
    intro:
      "Der Wechsel des Energieanbieters ist einfacher, als viele denken – und Ihre Versorgung ist gesetzlich immer sichergestellt. Trotzdem lauern Fallstricke: verpasste Kündigungsfristen, unpassende Laufzeiten oder Lockangebote. Wir begleiten Sie durch den gesamten Prozess.",
    sections: [
      {
        heading: "So läuft Ihr Wechsel ab",
        body: "1. Wir analysieren Ihre aktuelle Rechnung und prüfen Fristen. 2. Wir finden den passenden Tarif und erklären ihn transparent. 3. Auf Wunsch kündigen wir Ihren Altvertrag und melden Sie beim neuen Anbieter an. 4. Der neue Versorger übernimmt – Sie merken vom Wechsel nichts außer der niedrigeren Rechnung.",
      },
      {
        heading: "Ihre Versorgung ist immer sicher",
        body: "Beim Anbieterwechsel bleibt das Netz dasselbe – der Strom oder das Gas kommt physisch weiterhin zuverlässig bei Ihnen an. Es ändert sich nur, mit wem Sie Ihren Vertrag haben. Eine Versorgungslücke ist gesetzlich ausgeschlossen.",
      },
      {
        heading: "Sonderkündigungsrecht clever nutzen",
        body: "Erhöht Ihr Anbieter die Preise oder gerät er in Schieflage, haben Sie oft ein Sonderkündigungsrecht. Wir prüfen Ihre Situation und handeln rechtzeitig, damit Sie keine Frist verpassen und nicht in einen teuren Ersatz- oder Grundversorgertarif rutschen.",
      },
    ],
    benefits: [
      { title: "Rundum-Wechselservice", text: "Kündigung, Anmeldung und Abwicklung erledigen wir komplett für Sie." },
      { title: "Keine Versorgungslücke", text: "Ihre Belieferung ist während des gesamten Wechsels lückenlos gesichert." },
      { title: "Fristen im Blick", text: "Wir überwachen Kündigungs- und Sonderkündigungsfristen, damit nichts verfällt." },
      { title: "Persönliche Begleitung", text: "Ein fester Ansprechpartner statt anonymem Callcenter – von Anfang bis Ende." },
    ],
    stat: { value: "0 €", label: "Kosten & Risiko für Ihren Anbieterwechsel" },
    faqs: [
      { q: "Kann es beim Wechsel zu einem Stromausfall kommen?", a: "Nein. Ihre Versorgung ist gesetzlich abgesichert und läuft lückenlos weiter. Es ändert sich lediglich Ihr Vertragspartner, nicht die physische Belieferung." },
      { q: "Wie lange dauert ein Anbieterwechsel?", a: "In der Regel wenige Wochen. Der neue Anbieter kümmert sich um die Ummeldung; wir behalten Fristen und Ablauf für Sie im Blick." },
      { q: "Was, wenn ich noch in einem Vertrag gebunden bin?", a: "Wir prüfen Ihre Kündigungsfrist und ein mögliches Sonderkündigungsrecht – und planen den Wechsel passend zum Vertragsende." },
    ],
  },

  "gas-gewerbe": {
    slug: "gas-gewerbe",
    eyebrow: "Gas für Gewerbekunden",
    titleLines: ["Gastarife für", '<span class="font-serif italic text-blue-700">Gewerbe & Industrie.</span>'],
    subtitle:
      "Gewerblicher Gasbezug folgt eigenen Regeln: höhere Mengen, Lastprofile und volatile Beschaffungsmärkte. Wir strukturieren Ihren Gaseinkauf transparent und wirtschaftlich – vom Handwerksbetrieb bis zur Produktion.",
    image: IMAGES.gas,
    ctaTopic: "gas",
    intro:
      "Für Unternehmen ist Gas selten nur ein Kostenpunkt, sondern ein planbarer Wirtschaftsfaktor. Wir analysieren Ihren Verbrauch, bewerten SLP- und RLM-Lastprofile und sichern Konditionen zum richtigen Zeitpunkt – ohne die überhöhten Risikozuschläge, die viele Standardangebote enthalten.",
    sections: [
      {
        heading: "SLP oder RLM – die richtige Vertragsart",
        body: "Bis 1,5 Mio. kWh gilt in der Regel das Standardlastprofil (SLP), darüber die registrierende Leistungsmessung (RLM) mit stündlicher Erfassung. Für RLM-Kunden lassen sich durch börsennahe Beschaffung erhebliche Vorteile erzielen. Wir ermitteln, welche Struktur zu Ihrem Betrieb passt.",
      },
      {
        heading: "Beschaffung zum richtigen Zeitpunkt",
        body: "Gaspreise schwanken stark. Statt zum Höchststand zu verlängern, beobachten wir den Markt und empfehlen den passenden Einkaufszeitpunkt. Bei größeren Mengen strukturieren wir die Beschaffung, um Preisspitzen zu glätten und Planungssicherheit zu schaffen.",
      },
      {
        heading: "Mehrere Standorte gebündelt",
        body: "Filialunternehmen und Betriebe mit mehreren Entnahmestellen profitieren von gebündelter Beschaffung: einheitliche Konditionen, ein Ansprechpartner und weniger Verwaltungsaufwand – bei voller Kostentransparenz.",
      },
    ],
    benefits: [
      { title: "RLM-Lastprofilanalyse", text: "Individuelle Auswertung Ihres Verbrauchs für die optimale Beschaffungsstrategie." },
      { title: "Börsennahe Konditionen", text: "Zugang zu Preisen abseits teurer Standard- und Risikozuschläge." },
      { title: "Planbare Energiekosten", text: "Strukturierte Beschaffung glättet Preisspitzen und schafft Budgetsicherheit." },
      { title: "Bündelung mehrerer Standorte", text: "Einheitliche Verträge und ein Ansprechpartner für alle Entnahmestellen." },
    ],
    stat: { value: "1,5 Mio", label: "kWh – ab hier lohnt sich RLM-optimierte Beschaffung besonders" },
    faqs: [
      { q: "Ab welchem Verbrauch lohnt sich eine individuelle Gasbeschaffung?", a: "Bereits ab mittlerem Gewerbeverbrauch kann sich eine unabhängige Analyse lohnen. Bei RLM-Kunden mit hohem Verbrauch sind die Potenziale besonders groß." },
      { q: "Was ist die MaLo-ID und wozu brauchen Sie sie?", a: "Die Marktlokations-ID identifiziert Ihre Entnahmestelle eindeutig. Sie steht auf Ihrer Rechnung und ermöglicht uns eine präzise Angebotserstellung." },
      { q: "Können Sie mehrere Standorte gemeinsam beschaffen?", a: "Ja. Wir bündeln mehrere Entnahmestellen in einer Beschaffung – für einheitliche Konditionen und minimalen Verwaltungsaufwand." },
    ],
  },
};

export const TARIFE_LIST = Object.values(TARIFE);
export const getTarif = (slug) => TARIFE[slug];
